module.exports = __webpack_public_path__ + "static/img/eureka_icon_1.6dd369e3.png";